import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/* Bank/NBFC approval state from /dashboard/stats; non-bank roles are always "approved". */
export function useBankStatus() {
  const { user } = useAuth();
  const isBank = user?.role === "bank";
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(isBank);
  useEffect(() => {
    if (!isBank) return undefined;
    let alive = true;
    api.get("/dashboard/stats").then((r) => { if (alive) setStats(r.data); }).catch(() => {}).finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [isBank]);
  return { loading, approved: isBank ? Boolean(stats?.is_approved) : true, stats };
}
